module.exports = __webpack_public_path__ + "images/emoji/icecream.c985ce872c4b92b9174f.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/emoji/icecream.png
// module id = Dg3h
// module chunks = 2